import { combineReducers } from '@reduxjs/toolkit'

import { reducer as firstDoctor } from './firstDoctor'

export default combineReducers({ firstDoctor })
